import firestore from "../firebase/firestore";

const placesRef = firestore.collection("places");

export const getPlaces = () => placesRef.orderBy("name");

export const getActivePlaces = () => placesRef.where("active", "==", true);

export const createPlace = (data) =>
  placesRef.add({
    ...data,
    active: true,
    created_at: new Date(),
    updated_at: new Date(),
  });

export const updatePlace = (id, data) =>
  placesRef.doc(id).update({
    ...data,
    updated_at: new Date(),
  });

export const deletePlace = (id) =>
  updatePlace(id, {
    active: false,
    deleted_at: new Date(),
  });
